import { mqMdDown, isMqMdDown } from '../data/_variables';

$(window).on('scroll', () => {
  let winTop = $(window).scrollTop();
  $('#header')
    .find('.menu-icon')
    .toggleClass('bg-show', winTop > 0);
});
